import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
const logger = createLogger(__filename);

const featureFlagsApiClient = {
  fetchFeatureFlags: async (): Promise<string[]> => {
    const url = new URL(`/app/v1/features`, API_BASE_URL);
    logger.trace('featureFlagsApiClient.featureFlags()');
    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
};

export default featureFlagsApiClient;
